import Immutable from 'immutable';
var CmsRecord = new Immutable.Record({
  id: '',
  isFetching: false,
  data: Immutable.List()
});
export default CmsRecord;